<script>
import Vue          from 'vue';
import { Pie }      from 'vue-chartjs'

export default {
    extends: Pie,
    props: {
        chart: {
            type: Object,
            default: null
        },
        settings: {}
    },
    data() {
        return {
            data: {},
            chartType: '',
            chartData: { borderAlign: 'center' },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { position: 'right' },
            }
        }
    },
    created() {
        Vue.$log.info('※ PieChart.vue created data =>', this.chart);
        if(this.chart !== null) {
            this.chartType = this.chart.chartType;
            this.data = this.chart.chartData[0];
        };

        if(this.chartType === 'QA') {
            Object.assign(this.chartData, {
                labels : ['Open', 'Close'],
                datasets: [{
                    data: [ this.data.OPEN, this.data.CLOSE ],
                    // 파랑 #364fc7 하늘 #60c0dc 주황 #ff8c58 초록 #5fb760
                    backgroundColor: ['#364fc7', '#60c0dc', '#ff8c58', '#5fb760'],
                }]
            });

        } else {
            // type ICO, MRCO
            Object.assign(this.chartData, {
                labels : ['Unread', 'Read'],
                datasets: [{
                    data: [ this.data.NOT_YET, this.data.READ ],
                    backgroundColor: ['#364fc7', '#60c0dc', '#ff8c58', '#5fb760'],
                }]
            });
        }

        Object.assign(this.options, {
            title: { display: true, position: 'bottom', text: this.data.KNOWLEDGE_TITLE },
        });
    },
    mounted () {
        this.renderChart(this.chartData, this.options);
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/dashboard/charts/PieChart.vue